<template>
  <div class='myTile'>
    <p class='title is-3 is-6-mobile'>the infection spreads</p>
    <div class='has-text-left'>
      <p>Within minutes of becoming infected <span class='userName'>woodendoors7</span> started a chain reaction. In under an hour, the virus spread to <span class='myNumber'>{{ infectedHour1 }}</span> users. In under a day, <span class='myNumber'>{{ infectedDay1 }}</span> were sick.
      </p>
      <br>
      <p class='chartTitle'>Figure 1: Infections in the first hour</p>
      <hr class='rule'>
    </div>

    <div>
      <GChart
        :settings="{ packages: ['wordtree'] }"
        type="WordTree"
        :data="responsiveWordTreeData"
        :options="{maxFontSize: responsiveWordTreeFontSize, backgroundColor: '#F0F0F0', wordtree: {format:'explicit'}, fontName: 'Permanent Marker'}"
      ></GChart>
          <!--  make the max font size 16 for mobile -->
    </div>
  </div>      
  
</template>

<script>
import { GChart } from "vue-google-charts";

export default {
  props: ['mobile'],
  data() {
    return {
      infectedHour1: '26',
      infectedDay1: '2,780',
      wordTreeData: [
          ['id', 'childLabel', 'parent', 'size', { role: 'style' }],
          [0, 'woodendoors7', -1, 1, '#F14668'],
          [1, 'austind9999', 0, 1, '#333'],
          [2, 'unclerico589', 0, 1, '#333'],
          [3, 'saikmat', 0, 1, '#333'],
          [4, 'SCRU8YDOO', 0, 1, '#333'],
          [5, 'thesouplovers', 0, 1, '#333'],
          [6, 'roliravioli78', 0, 1, '#333'],
          [7, 'Gardyloomphus', 0, 1, '#333'],
          [8, 'YashSSJB1', 0, 1, '#333'],
          [9, 'PrideInModesty', 0, 1, '#333'],
          [10, 'schloooooooop', 0, 1, '#333'],
          [11, 'spacincommie', 0, 1, '#333'],
          [12, 'Calvincake911meme', 0, 1, '#333'],
          [13, 'just_a_guy321', 0, 1, '#333'],
          [15, 'Nash_underscore', 0, 1, '#333'],
          [16, 'Ben_Herr', 0, 1, '#333'],
          [19, 'ollopii', 0, 1, '#333'],
          [24, 'Thememescontrolme', 0, 1, '#333'],

          [14, 'Bit_of_a_Hater', 4, 1, '#333'],
          [26, '', 4, 1, '#333'],

          [17, 'YoshiNinja_YT', 15, 1, '#333'],
          [27, '', 15, 1, '#333'],

          [18, 'cos_tan_za', 16, 1, '#333'],
          [22, 'bappodrinklacto', 16, 1, '#333'],
          [25, 'IronGoat69', 16, 1, '#333'],

          [20, 'Frugal-Redditor', 19, 1, '#333'],
          [28, '', 19, 1, '#333'],

          [21, 'TAKirbyStar_', 1, 1, '#333'],
          [23, 'tadoba2', 1, 1, '#333'],
      ],
      mobileWordTreeData: [
          ['id', 'childLabel', 'parent', 'size', { role: 'style' }],
          [0, 'woodendoors7', -1, 1, '#F14668'],
          [1, '1', 0, 1, '#333'],
          [2, '2', 0, 1, '#333'],
          [3, '3', 0, 1, '#333'],
          [4, '4', 0, 1, '#333'],
          [5, '5', 0, 1, '#333'],
          [6, '6', 0, 1, '#333'],
          [7, '7', 0, 1, '#333'],
          [8, '8', 0, 1, '#333'],
          [9, '9', 0, 1, '#333'],
          [10, '10', 0, 1, '#333'],
          [11, '11', 0, 1, '#333'],
          [12, '12', 0, 1, '#333'],
          [13, '13', 0, 1, '#333'],
          [15, '15', 0, 1, '#333'],
          [16, '16', 0, 1, '#333'],
          [19, '19', 0, 1, '#333'],
          [24, '24', 0, 1, '#333'],

          [14, '14', 4, 1, '#333'],
          [26, '', 4, 1, '#333'],

          [17, '17', 15, 1, '#333'],
          [27, '', 15, 1, '#333'],

          [18, '18', 16, 1, '#333'],
          [22, '22', 16, 1, '#333'],
          [25, '25', 16, 1, '#333'],

          [20, '20', 19, 1, '#333'],
          [28, '', 19, 1, '#333'],

          [21, '21', 1, 1, '#333'],
          [23, '23', 1, 1, '#333'],
      ],
    }
  },
  computed: {
    responsiveWordTreeFontSize() {
      return this.mobile ? 14 : 20;
    },
    responsiveWordTreeData() {
      return this.mobile ? this.mobileWordTreeData : this.wordTreeData;
    },
  },
  components: {
    GChart
  }
}


</script>